<template>
  <div style="height:100%">
    <!--    签离成功失败弹框-->
    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="notify.show = false"></my-notify-dialog>


    <div class="common-page-box">
      <div class="back-btn" @click="$router.back()">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>

      <div class="page-title" style="margin-top:48px">{{ title }}</div>

      <div class="card" style="margin:56px 96px 96px;flex:1;padding:72px 120px 64px;display:flex;flex-direction:column">
        <!-- 待扫码：开始按钮 + 同意 + 须知 -->
        <template v-if="step === 0 && !showApplyList">
          <div style="display:flex;flex-direction:column;align-items:center;gap:36px">
            <button class="ta-btn primary" style="width:860px;height:140px;font-size:48px;border-radius:24px" @click="onStartScanClick2">开始二维码签离
            </button>
            <div v-if="agreement.valid" class="agree" @click="haveRead = !haveRead">
              <span class="box" :class="{checked: haveRead}">
                <svg v-if="haveRead" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>
              </span>
              <span>请阅读并同意<a>《{{ agreementTitle }}》</a></span>
            </div>
          </div>

          <div class="notice" style="margin-top:auto;border-top:1px solid var(--line);padding-top:56px">
            <h3>{{ agreementTitle }}</h3>
            <div v-if="agreement.valid" v-html="agreement.content"></div>
            <div v-else>
              访问结束，签离前请注意：<br>
              1. 请出示签到时使用的二维码、访客码或预留手机号完成签离；<br>
              2. 请携带好个人物品，有序离开；<br>
              感谢您的配合，欢迎再次来访。
            </div>
          </div>
        </template>

        <!-- 扫码结果：预约列表 -->
        <template v-else-if="showApplyList">
          <el-table :data="applyList" style="width:100%">
            <el-table-column prop="myVisitorName" label="访客"></el-table-column>
            <el-table-column prop="myEmployeeName" label="受访者"></el-table-column>
            <el-table-column prop="myBeginTime" label="开始时间"></el-table-column>
            <el-table-column prop="myEndTime" label="结束时间"></el-table-column>
            <el-table-column prop="myStatus" label="状态">
              <template v-slot="scope">
                <el-tag>{{ scope.row.myStatus | tableDateFilter }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template v-slot="scope">
                <el-button :disabled="scope.row.myStatus !== 'PASS'" @click="doSignLeave(scope.row.data)"
                           type="success">
                  签离
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <!-- 扫码中过渡态（壳内为原生前置扫码屏，自带取景框+提示，H5 不再叠一套否则双份提示） -->
        <div v-else-if="!shellScan" class="scan-stage">
          <div class="scan-hole">
            <span class="corner tl"></span><span class="corner tr"></span>
            <span class="corner bl"></span><span class="corner br"></span>
            <div class="scanline"></div>
          </div>
          <div class="scan-tip">将二维码/条形码放入框内</div>
        </div>
      </div>

      <div class="back-btn" v-if="step === 1" style="background:rgba(255,255,255,.92)" @click="onCancelClick">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>
    </div>

  </div>
</template>
<script>

import {QrcodeStream} from 'vue-qrcode-reader'
import {isBridgeAvailable, nativeScanCode} from "@/utils/native-bridge";
import BackIcon from "@/components/BackIcon.vue";
import {getApplyListByPinCode, getApplyListByVisitCode, getApplyListByQrCode, getUserInfo, signLeave} from "@/api/visit-api";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {aesDec} from "@/utils/cryptoUtils";
import {areaCheckMixin} from "@/utils/myMixins";
import {usual_visitor_sign_mixin} from "@/helper/usual_visitor_mixin";

export default {
  name: "QRCodeLeave",
  components: {
    MyNotifyDialog,
    BackIcon,
    QrcodeStream
  },
  mixins: [areaCheckMixin, usual_visitor_sign_mixin],
  mounted() {
    this.setupAreaInfo()
    window.addEventListener('inputEnd', this.handleInputFromJava)
  },
  destroyed() {
    window.removeEventListener('inputEnd', this.handleInputFromJava)
  },
  computed: {
    agreement() {
      return this.$store.state.signLeaveAgreement
    },

    // 壳内扫码走原生浮层（自带取景框+提示+取消），H5 侧不再画自己的过渡态
    shellScan() {
      return isBridgeAvailable()
    },

    deviceType() {
      return this.mCfg.DEVICE_TYPE
    }
  },
  data() {
    return {
      step: 0,
      title: "扫码签离",
      haveRead: false,

      qrScan: false,

      qrResult: "",
      paused: "off",

      subTitle: "访客码",
      inputCode: "",


      applyList: [],
      showApplyList: false,

      userInfo: null,
      agreementDialogVisible: false,

      notify: {
        title: "签到结果",
        show: false,
        success: true,
        msg: "签到成功",
      },

      scanResultTypeCode: false,

      agreementTitle: "签离须知",
    }
  },

  methods: {
    onStartScanClick() {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }

      this.qrScan = true
      this.paused = 'front'
    },

    onStartScanClick2() {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }

      // h5pack 壳内优先走原生扫码（vision-camera，不依赖 WebView 的 getUserMedia 授权）
      if (isBridgeAvailable()) {
        this.step = 1
        nativeScanCode().then(code => {
          if (code) {
            this.onDecode(code)
          } else {
            this.step = 0 // 用户在原生浮层点「取消」
          }
        }).catch(err => {
          console.log("nativeScanCode err", err)
          this.$message.error(err && err.code === 'SCAN_NOT_ENABLED'
            ? "扫码能力未启用（壳工程 scanEnabled: true）"
            : "扫码失败，请重试")
        })
        return
      }

      this.step = 1
    },

    handleInputFromJava(event) {
      const param1 = event.detail
      console.log('handleInputFromJava ' + param1.result)
      this.onDecode(param1.result)
    },
    // 扫码结果回调
    onDecode(result) {
      if (!this.haveRead && this.agreement.valid) {
        this.$message.warning("请先阅读并同意" + this.agreementTitle)
        return
      }
      if (this.step === 0) {
        this.$message.warning("请点击开始二维码签离")
        return
      }

      console.log('onDecode get data ' + result)
      this.qrScan = false
      this.paused = 'off'
      this.qrResult = result

      if (result.length === 8) {
        this.onGetPinCodeResult(result)
      } else if (/^\d+$/.test(result)) {
        // 纯数字非 8 位=动态访客码（小程序 15 秒刷新码/纸质码，t_qr_link），后端按 code 反查预约
        this.onGetQrCodeResult(result)
      } else {
        try {
          let jsonResult = aesDec(result)
          console.log("@@@", "jsonResult", jsonResult)
          let data = JSON.parse(jsonResult)
          if (data.type && data.code && data.time) {
            this.onGetScanResult(data.type, data.code, data.time)
          } else {
            this.$message.error("信息获取失败，请扫描正确的签离码")
          }
        } catch (e) {
          console.log(e)
          this.$message.error("信息获取失败，请扫描正确的签离码")

        }
      }
    },

    closeQrSteam() {
      this.qrScan = false
      this.paused = 'off'
      this.qrResult = ""
    },

    onGetPinCodeResult(pinCode) {
      this.scanResultTypeCode = true
      this.applyList = []
      getApplyListByPinCode(pinCode).then(({data}) => {
        console.log("getApplyListByPinCode", data)
        console.log(data)
        this.applyList = []
        if (data.code === 200) {
          this.step = 0
          // 已签离的预约不再显示（completeState=LEAVE）
          let rawList = data.data || []
          let applyList = rawList.filter(item => item.completeState !== "LEAVE")
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: item.pinVisitor.name,
                myEmployeeName: (item.employee || {}).name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true;
            if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignLeave(this.applyList[0].data)
            }
          } else if (rawList.length > 0) {
            this.$message.warning("该访客均已签离，无需重复签离")
          } else {
            this.$message.warning("查询失败，未能找到对应的申请记录")
          }
        } else {
          this.showServerErrMsg(data.code)
          this.logE("VisitCodeCome getApplyListByPinCode false", data.code, data.msg)
        }
      }).catch(err => {
        console.log("getApplyListByPinCode err ", err)
        this.showNetErrMsg()
      })

    },

    onGetQrCodeResult(qrCode) {
      this.scanResultTypeCode = false
      console.log("onGetQrCodeResult", qrCode)
      this.applyList = []
      getApplyListByQrCode(qrCode).then(({data}) => {
        console.log("getApplyListByQrCode", data)
        this.applyList = []
        if (data.code === 200) {
          this.step = 0
          // 已签离的预约不再显示（completeState=LEAVE）
          let rawList = data.data || []
          let applyList = rawList.filter(item => item.completeState !== "LEAVE")
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: (item.pinVisitor || item.visitor || {}).name,
                myEmployeeName: (item.employee || {}).name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true;
            if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignLeave(this.applyList[0].data)
            }
          } else if (rawList.length > 0) {
            this.$message.warning("该访客均已签离，无需重复签离")
          } else {
            this.$message.warning("二维码已失效，请在小程序中刷新访客码后重试")
          }
        } else {
          this.showServerErrMsg(data.code)
          this.logE("QRCodeLeave getApplyListByQrCode false", data.code, data.msg)
        }
      }).catch(err => {
        console.log("getApplyListByQrCode err ", err)
        this.showNetErrMsg()
      })
    },

    onGetScanResult(type, code, time) {
      this.scanResultTypeCode = false
      console.log("onGetScanResult", type, code, time)
      this.applyList = []

      getUserInfo(code).then(({data}) => {
        console.log("getUserInfo", data)
        console.log(data)
        if (data.code === 200) {
          this.userInfo = data.data
          if (this.checkIsVisitorUsual(data.data)) {
            let areaId = this.$store.state.areaId
            let deviceId = this.$store.state.deviceId
            this.doUsualSignLeave(data.data, deviceId, areaId)
            return
          }
          this.doGetApplyListByVisitId(code, this.userInfo.name)
        } else {
          this.showServerErrMsg(data.code)
          this.logE("VisitCodeCome getUserInfo false", data.code, data.msg)
        }
      }).catch(err => {
        console.log("getUserInfo err ", err)
        this.showNetErrMsg()
      })


    },

    doGetApplyListByVisitId(code, name) {
      getApplyListByVisitCode(code).then(({data}) => {
        this.step = 0

        console.log("getApplyListByVisitId", data)
        console.log(data)
        this.applyList = []
        if (data.code === 200) {
          let applyList = data.data
          if (applyList.length > 0) {
            applyList.forEach(item => {
              this.applyList.push({
                myVisitorName: name,
                myEmployeeName: (item.employee || {}).name,
                myBeginTime: item.beginDate + " " + item.beginTime,
                myEndTime: item.endDate + " " + item.endTime,
                myStatus: item.state,
                data: item
              })
            })
            this.showApplyList = true;
            if (this.applyList.length === 1 && this.applyList[0].myStatus === "PASS") {
              this.doSignLeave(this.applyList[0].data)
            }
          } else {
            this.$message.warning("查询失败，未能找到对应的申请记录")
          }
        } else {
          this.showServerErrMsg(data.code)
          this.logE("VisitCodeCome getApplyListByPinCode false", data.code, data.msg)
        }
      }).catch(err => {
        console.log("getApplyListByVisitId err ", err)
        this.showNetErrMsg()
      })
    },

    onCancelClick() {
      this.paused = 'off'
      this.qrScan = false
      this.$router.back()
    },


    doSignLeave(applyInfo) {
      let applyId = applyInfo.id
      // 访客码取值优先级：pin/qr 响应自带 pinVisitor → AES 分支的 userInfo → 兜底 visitor。
      // 此前二维码动态码分支错误依赖 this.userInfo（初始 null），扫码签离会直接抛错
      let visitorCode = (applyInfo.pinVisitor && applyInfo.pinVisitor.code)
        || (this.userInfo && this.userInfo.code)
        || (applyInfo.visitor && applyInfo.visitor.code)
      let deviceId = this.$store.state.deviceId
      let areaId = this.$store.state.areaId
      signLeave(applyId, visitorCode, deviceId, areaId).then(({data}) => {
        console.log("signLeave", data)
        if (data.code === 200) {
          if (data.data.exist === "EXIST") {
            this.notify = {title: "签离结果", show: true, false: true, msg: "您已签离，无需再次签离",}
          } else {
            this.notify = {title: "签离结果", show: true, success: true, msg: "签离成功",}
          }
        } else if (data.code === 720) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "未同意签离或者签离超时",
          }
        } else if (data.code === 201) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败，没有找到签到记录",
          }
        } else if (data.code === 201) {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败，没有找到签到记录",
          }
        } else {
          this.notify = {
            title: "签离结果",
            show: true,
            success: false,
            msg: "签离失败",
          }
        }

      }).catch((err) => {
        this.logE("VisitCodeCome signLeave err", err)
        this.notify = {
          title: "签离结果",
          show: true,
          success: false,
          msg: "签离失败，网络异常",
        }
      })
    },
    onDialogEnsure() {
      this.agreementDialogVisible = false
      this.haveRead = true
    },
    switchCamera() {
      if (this.paused === 'front') {
        this.paused = 'rear'
      } else {
        this.paused = 'front'
      }
    },
  }, // end methods

  filters: {
    tableDateFilter(value) {
      switch (value) {
        case 'PASS':
          return "审批通过"
        case 'REJECT':
          return "审批拒绝"
        case 'CANCEL':
          return "审批撤销"
        case 'PROCESS ':
        case 'NONE ':
        default:
          return "审批中"
      }
    }
  }
}
</script>
<style scoped lang="less">
.back-btn {
  z-index: 40;
}

.card {
  position: relative;
  overflow: hidden;
}

.agree {
  cursor: pointer;

  .box {
    display: flex;
    align-items: center;
    justify-content: center;

    &.checked {
      background: var(--blue);
      border-color: var(--blue);
    }
  }
}

.scan-stage {
  position: absolute;
  inset: 0;
  background: #3a4038;
  overflow: hidden;

  .scan-hole {
    position: absolute;
    left: 50%;
    top: 46%;
    transform: translate(-50%, -50%);
    width: 640px;
    height: 640px;
    box-shadow: 0 0 0 2000px rgba(15, 18, 14, 0.55);
    border-radius: 8px;
  }

  .corner {
    position: absolute;
    width: 72px;
    height: 72px;
    border: 8px solid #3dff5c;

    &.tl { top: -8px; left: -8px; border-right: none; border-bottom: none; border-radius: 8px 0 0 0; }
    &.tr { top: -8px; right: -8px; border-left: none; border-bottom: none; border-radius: 0 8px 0 0; }
    &.bl { bottom: -8px; left: -8px; border-right: none; border-top: none; border-radius: 0 0 0 8px; }
    &.br { bottom: -8px; right: -8px; border-left: none; border-top: none; border-radius: 0 0 8px 0; }
  }

  .scanline {
    position: absolute;
    left: 24px;
    right: 24px;
    height: 6px;
    border-radius: 3px;
    background: linear-gradient(90deg, transparent, #3dff5c, transparent);
    box-shadow: 0 0 24px #3dff5c;
    animation: scan 2.4s ease-in-out infinite;
  }

  @keyframes scan {
    0%, 100% { top: 24px; }
    50% { top: calc(100% - 30px); }
  }

  .scan-tip {
    position: absolute;
    left: 50%;
    top: calc(46% + 380px);
    transform: translateX(-50%);
    color: #fff;
    font-size: 38px;
    letter-spacing: 0.06em;
    white-space: nowrap;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
  }
}

</style>

